<app-header [transparent]="transparent" />
<div class="pr_detail">
  <div class="pr_detail_top bg_1 inline_padding1 p-top-132">
    <div class="pr_detail_top_flex">
      <div class="text_blue_5 p-y-18 cursor-pointer" routerLink="/">
        <a>Home</a>
      </div>
      <div class="p-l-16 p-y-18">
        <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.31367 7.85721L6.7222 4.44452C6.80933 4.38951 6.87927 4.32127 6.92722 4.24449C6.97517 4.1677 7 4.08419 7 3.99968C7 3.91517 6.97517 3.83165 6.92722 3.75487C6.87927 3.67809 6.80933 3.60985 6.7222 3.55484L1.31367 0.142143C0.797419 -0.18355 0 0.0864778 0 0.58698L0 7.41335C0 7.91386 0.797419 8.18388 1.31367 7.85721Z"
            fill="#303030" />
        </svg>
      </div>
      <div class="text_blue_5 p-l-16 p-y-18 cursor-pointer" routerLink="/press-release">
        <a>Press Release</a>
      </div>
      <div class="p-l-16 p-y-18">
        <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.31367 7.85721L6.7222 4.44452C6.80933 4.38951 6.87927 4.32127 6.92722 4.24449C6.97517 4.1677 7 4.08419 7 3.99968C7 3.91517 6.97517 3.83165 6.92722 3.75487C6.87927 3.67809 6.80933 3.60985 6.7222 3.55484L1.31367 0.142143C0.797419 -0.18355 0 0.0864778 0 0.58698L0 7.41335C0 7.91386 0.797419 8.18388 1.31367 7.85721Z"
            fill="#303030" />
        </svg>
      </div>
      <div class="text_black_8 p-l-16 p-y-18 text-wrap">
        <span [innerHTML]="getDetails?.title"></span>
      </div>
    </div>
  </div>
  <div class="pr_detail_body inline_padding1  bg_2">
    <div class="pr_detail_body_flex">
      @if(getDetails){
      <div class="pr_detail_body_flex_left  bg_1 border-radius-20">
        <div class="pr_detail_body_flex_left_logo p-y-42 bg_2 border-radius-20">
          <img width="30%" [src]="getPressReleaseImageUrl(getDetails)" />
        </div>
        <div class="pr_detail_body_flex_left_content p-x-20 p-b-40">
          <div class="p-top-32 text_black_7 text-wrap" [innerHtml]="getDetails.title">

          </div>
          <div class="p-top-24 text_align text-wrap" [innerHtml]="getDetails.description">

          </div>
          <div *ngIf="getDetails.web_link" class="p-top-12">
            <button type="button" class="rounded-pill text_white_1 button_blue_7"
              (click)="openLink(getDetails.web_link)"><span class="button_blue_1_text"> Weblink</span> <img
                class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png" /></button>
          </div>
          <div class="share-buttons" style="margin-top:15px;">
            <button (click)="copyLink()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fas fa-link" style="color: #000;"></i> <!-- Copy Link -->
            </button>
            <button (click)="shareViaEmail()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fas fa-envelope" style="color: #EA4335;"></i> <!-- Email -->
            </button>
            <button (click)="shareViaSMS()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fas fa-sms" style="color: #25D366;"></i> <!-- SMS -->
            </button>
            <button (click)="shareViaWhatsApp()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fab fa-whatsapp" style="color: #25D366;"></i> <!-- WhatsApp -->
            </button>
            <button (click)="shareViaMessenger()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fab fa-facebook-messenger" style="color: #0084FF;"></i> <!-- Messenger -->
            </button>
            <button (click)="shareViaViber()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fab fa-viber" style="color: #59267C;"></i> <!-- Viber -->
            </button>
            <button (click)="shareViaFacebook()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fab fa-facebook" style="color: #4267B2;"></i> <!-- Facebook -->
            </button>
            <button (click)="shareViaTwitter()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fab fa-twitter" style="color: #1DA1F2;"></i> <!-- Twitter -->
            </button>
            <button (click)="shareViaLinkedIn()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fab fa-linkedin" style="color: #0077B5;"></i> <!-- LinkedIn -->
            </button>
            <button (click)="shareViaPinterest()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fab fa-pinterest" style="color: #E60023;"></i> <!-- Pinterest -->
            </button>
            <button (click)="shareViaReddit()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fab fa-reddit" style="color: #FF4500;"></i> <!-- Reddit -->
            </button>
            <button (click)="shareViaTumblr()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fab fa-tumblr" style="color: #35465C;"></i> <!-- Tumblr -->
            </button>
            <button (click)="shareViaTelegram()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fab fa-telegram" style="color: #0088CC;"></i> <!-- Telegram -->
            </button>
            <button (click)="shareViaVK()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fab fa-vk" style="color: #4B7BE5;"></i> <!-- VK -->
            </button>
            <button (click)="shareViaMix()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fab fa-mix" style="color: #00A3E0;"></i> <!-- Mix -->
            </button>
            <button (click)="shareViaXing()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fab fa-xing" style="color: #006567;"></i> <!-- Xing -->
            </button>
            <button (click)="shareViaLine()" style="background: transparent; border: none; cursor: pointer;">
              <i class="fab fa-line" style="color: #00B900;"></i> <!-- Line -->
            </button>

          </div>
        </div>
      </div>
      }
      <div class="pr_detail_body_flex_right ">
        <div class="bg_2 border-radius-20 p-x-24 p-y-32">
          <div class="text_black_10">
            Related Press releases
          </div>
          <!-- <div class="p-top-16 font_16 weight_500 color_black">
                                Patent Updates
                            </div> -->
          <div class="dashboard_right_list">
            <div class="dis-flex p-top-24" *ngFor="let data of pressReleaseList">
              <div class="dis-flex flex_direction_col p-r-10 p-top-4">
                <img class="width-17 height-17" src="../../../assets/icons/circle_icon.png" />
                <div class="vl_2 height-100-per m-l-8"></div>
              </div>
              <div>
                <div class="text_blue_3 p-l-6">
                  {{data.press_release_date | date: 'dd-MM-yyyy' }} | Press Release
                </div>
                <div class="text_black_14 p-top-8 p-l-10 text-wrap" style="font-size: 14px;">
                  {{data.title}}
                </div>
                <div class="text_style_9 p-top-8 text_lines_5 p-l-10 text_align text-wrap" style="font-size: 14px;"
                  [innerHtml]="data.description">
                </div>
                <div class="p-l-10">
                  <span class="cursor-pointer text_blue_2" (click)="showFullContent(data)">Read News</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="p-top-40 p-b-60">
      <span class="text_black_9 p-l-10">You May Also Be Interested In...</span>
      <div class="pr_detail_body_cards p-top-24">
        <ng-container *ngFor="let data of pressReleaseList">
          <div class="pr_detail_body_cards_item m-b-24">
            <div class="card_2">
              <div class="card_2_img" style=" padding: 0; border: 0;background:none;">
                <img style="border-radius: 20px 20px 0 0;" class="card_2_img_sec" [src]="getPressReleaseImageUrl(data)"
                  alt="img" />
              </div>
              <div class="card_2_content">
                <div class="card_2_content_top">
                  <span class="text_blue_6" style="font-size: 12px;">{{data.press_release_date | date: 'dd-MM-yyyy'}} |
                    Press Release</span>
                </div>
                <div class="card_2_content_middle">
                  <div class="card_2_content_middle_title text_lines_2 text-wrap" style="padding-top: 10px;">
                    <span style="font-size: 15px;" class="text_black_1_res">{{data.title}}</span>
                  </div>
                  <div class="card_2_content_middle_normal text_lines_5 text-wrap text_align">
                    <span style="font-size: 14px;" class="text_black_3_res" [innerHtml]="data.description"></span>
                  </div>
                </div>
                <div class="card_2_content_bottom" (click)="showFullContent(data)">
                  <button type="button" class="rounded-pill text_white_1 button_blue_1"><span
                      class="button_blue_1_text">View More</span> <img class="button_blue_1_text_icon"
                      src="../../../assets/icons/arrow-right.png" /></button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<app-footer />